<template>
    <a-modal
      :width="'100%'"
      :visible="visible"
      :closable="false"
      :maskClosable="false"
      :title="null"
      :dialogStyle="{ top: 0 }"
      :destroyOnClose="true"
    >
      <template slot="footer">
        <!-- <a-button type="default" icon="right-circle" @click="handleCancel"
          >下一个</a-button
        >
        <a-divider type="vertical"></a-divider> -->
        <a-button type="default" @click="handleCancel">关闭</a-button>
        <a-button type="primary" @click="handleOk()">批改</a-button>
        <!-- <a-button type="primary" @click="handleOk('2')">批改</a-button> -->
        <!-- <a-button type="danger" @click="handleOk('-2')">重做</a-button> -->
      </template>
      <div>
        <!-- <a target="_blank" :href="'/scratch3/index.html?workId=' + this.model.id">查看代码</a> -->
        <iframe :src="getEditorUrl(model)" id="player" frameborder="0" width="100%" height="100%" scrolling="no"></iframe>
        <a-divider />
        <a-form :form="form">
          <a-row type="flex" justify="space-between">
            <a-col :span="4">
              <a-card>
                <a-row>
                  <a-col :span="8">学生名：</a-col>
                  <a-col :span="16">{{ model.realname }}</a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">作业名：</a-col>
                  <a-col :span="16">{{ model.workName }}</a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">课程单元：</a-col>
                  <a-col :span="16">{{ model.unitName }}</a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">班级：</a-col>
                  <a-col :span="16">{{ model.departId_dictText }}</a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">提交时间：</a-col>
                  <a-col :span="16">{{ model.updateTime || model.createTime }}</a-col>
                </a-row>
              </a-card>
            </a-col>
            <a-col v-if="model.contestId" :span="6">
              <a-card>
                <p>创作思想：</p>
                <p>{{model.workDesc}}</p>
                <p>创作过程：</p>
                <p>{{model.playDesc}}</p>
                <p>参考资源：</p>
                <p>{{model.workRef}}</p>
              </a-card>
            </a-col>
            <a-col v-else :span="6">
              <a-card>
                <p>作品介绍：</p>
                <p>{{model.workDesc}}</p>
                <p>操作介绍：</p>
                <p>{{model.playDesc}}</p>
              </a-card>
            </a-col>
            <a-col :span="6">
              <a-form-item label="评语" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-textarea
                  v-decorator="['comment', validatorRules.comment]"
                  maxlength="150"
                  placeholder="请输入评语"
                ></a-textarea>
                <j-dict-select-tag
                  ref="dictSelectTag"
                  :triggerChange="true"
                  :canDeleteItem="true"
                  @change="selectComment"
                  dictCode="work_comment"
                  placeholder="选择常用评语"
                />
                <a @click="saveComment">保存为常用评语</a>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item
                label="状态"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
              >
                <j-dict-select-tag
                  type="radioButton"
                  :triggerChange="true"
                  v-decorator="['workStatus', validatorRules.workStatus]"
                  dictCode="work_status"
                  placeholder="请选择状态"
                />
              </a-form-item>
  
              <a-form-item label="评分" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-rate v-decorator="['score', validatorRules.score]" />
                <br />
                <!-- <a-tooltip> -->
                  <!-- <span slot="title">该作业将在学生端"教师推荐"栏展示七天</span> -->
                  <a-switch @change="workStatueChange" :checked="model.workStatus == 3">
                    <a-icon slot="checkedChildren" type="check" />
                    <a-icon slot="unCheckedChildren" type="close" />
                  </a-switch>
                  <a-divider type="vertical"></a-divider>
                  <span>推荐优秀作业</span>
                <!-- </a-tooltip> -->
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
  </template>
  
  <script>
  import pick from 'lodash.pick'
  import { httpAction, postAction, putAction } from '@/api/manage'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import { getAction } from '@/api/manage'
  export default {
    name: 'WorkReviewModal',
    components: {
      JDictSelectTag,
    },
    data() {
      return {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 16,
        },
        labelCol2: {
          span: 3,
        },
        wrapperCol2: {
          span: 20,
        },
        form: this.$form.createForm(this),
        visible: false,
        model: {},
        url: {
          correntInfo: '/teaching/teachingWork/queryTeachingWorkCorrectByMainId',
          correctWork: '/teaching/teachingWork/correctWork',
          saveUsualComment: '/teaching/teachingWork/saveUsualComment',
        },
        validatorRules: {
          workStatus: {
            rules: [
              { required: true, message: '请选择状态!' },
              { pattern: /^-[1-2]|[2-3]$/, message: '请选择正确的状态！' },
            ],
          },
          score: { rules: [{ required: true, message: '请选择评分!' }] },
          comment: {},
        },
      }
    },
    created() {},
    methods: {
      edit(record) {
        this.form.resetFields()
        this.model = Object.assign({}, record)
        this.visible = true
        this.getWorkCorrect()
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'id', 'workStatus'))
        })
      },
      getWorkCorrect(){
        getAction(this.url.correntInfo, {id: this.model.id}).then(res=>{
          if(res.success && res.result.length>0){
            this.form.setFieldsValue(pick(res.result[0], 'score', 'comment'))
          }
        })
      },
      getEditorUrl(workInfo) {
        let url
        switch (workInfo.codeType) {
          case 1:
            url = '/scratch3/index.html?workId=' + workInfo.id
            break
          case 2:
            url = '/scratch3/index.html?workId=' + workInfo.id
            break
          case 3:
            url = '/scratchjr/editor.html?mode=edit&workId=' + workInfo.id
            break
          case 4:
            url = '/onlinecode/index.html?lang=turtle&workId=' + workInfo.id
            break
          case 5:
            url = '/onlinecode/index.html?lang=python&workId=' + workInfo.id
            break
          case 6:
            url = '/onlinecode/index.html?lang=c&workId=' + workInfo.id
            break
          case 7:
            url = '/onlinecode/index.html?lang=cpp&workId=' + workInfo.id
            break
          case 8:
            url = '/onlinecode/index.html?lang=java&workId=' + workInfo.id
            break
          case 10:
            url = '/blockly/index.html?lang=zh-hans&workId=' + workInfo.id
            break
          default:
            url = '/scratch3/index.html?projectworkId=' + workInfo.id
        }
        return url
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk(v) {
        // if (this.model.workStatus != 3) {
        //   this.model.workStatus = v
        //   this.form.setFieldsValue({ workStatus: v })
        // }
  
        const that = this
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true
            let formData = Object.assign(this.model, values)
            console.log('表单提交数据', formData)
            httpAction(this.url.correctWork, formData, 'post')
              .then((res) => {
                if (res.success) {
                  if (res.result) {
                    that.$message.success('批改成功，开始批改下一个。')
                    that.edit(res.result)
                  } else {
                    that.$message.success('批改成功，已全部批改完毕。')
                    that.close()
                    that.$emit('finished')
                  }
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      handleCancel() {
        this.close()
      },
      selectComment(v) {
        this.model.comment = v
        this.form.setFieldsValue({ comment: v })
      },
      saveComment() {
        let comment = this.form.getFieldsValue(['comment']).comment
        console.log(comment)
        putAction(this.url.saveUsualComment, { comment: comment }).then((res) => {
          if (res.success) {
            //添加dict缓存
            this.$refs.dictSelectTag.addDictItems(comment,comment,comment,comment)
            this.$message.success(res.message)
          } else {
            this.$message.info(res.message)
          }
        })
      },
      workStatueChange(v) {
        if (v) {
          this.model.workStatus = 3
          this.form.setFieldsValue({ workStatus: 3 })
        } else {
          this.model.workStatus = 2
          this.form.setFieldsValue({ workStatus: 2 })
        }
      },
    },
  }
  </script>
  
  <style lang="less" scoped>
  iframe {
    display: block;
    height: 700px;
    margin: auto;
  }
  </style>